export const SETTINGS_SET_LAST_SELECTED_BRAND_ID = 'SETTINGS_SET_LAST_SELECTED_BRAND_ID'
export const SETTINGS_SET_PREVIEW_VIEWPORT = 'SETTINGS_SET_PREVIEW_VIEWPORT'
